import React from 'react'
import { WebcamCapture } from './webcam-capture'

const ImageCaptureWebcam = () => {
    return (

        <>
            <div className="page-title">
                <h1>Image Capture using Webcam</h1>
            </div>
            <div>
                <WebcamCapture />
            </div>
        </>
    )
}

export default ImageCaptureWebcam
